export const USER_SCHEDULE_HOURS = 8;
